import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CMSService } from '@core/cms';
import { HeaderSectionType } from '@feature/types';
import { Image } from '@shared/types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-section-header-container',
  templateUrl: './section-header-container.component.html',
  styleUrls: ['./section-header-container.component.scss'],
})
export class SectionHeaderContainerComponent implements OnInit {
  template:
    | 'main'
    | 'info'
    | 'simple'
    | 'list'
    | 'article'
    | 'promo'
    | 'empty'
    | 'faresale';
  sectionHeader: HeaderSectionType[];
  bgUrl = '';

  constructor(private cmsService: CMSService) {}

  ngOnInit(): void {
    this.sectionHeader = this.sectionHeader.map(section => {
      const bgImages = section.data?.bgImages;
      // check title, subtitle and content
      const hideSection =
        (section.data?.familyBlock?.length ?? 0) === 0 &&
        (section.data?.title?.length ?? 0) === 0 && // if property is undefined default to 0
        (section.data?.subtitle?.length ?? 0) === 0 &&
        (section.data?.content?.length ?? 0) === 0 &&
        ((section.data?.section as any)?.length ?? 0) === 0 && // check "components"
        ((section as any).section?.length ?? 0) === 0; // special case for "list" template

      Object.defineProperty(section, 'hideSection', {
        value: hideSection,
        enumerable: true,
      });

      if (!bgImages) {
        return section;
      }
      return {
        ...section,
        data: {
          ...section.data,
          bgUrl: this.getRandomizedImage(section.data?.bgImages),
        },
      };
    });
  }

  getRandomizedImage(images: Image[]) {
    // Picks random image index from the array parameter
    const randomizedIndex = this.cmsService.updateBackgroundIndex(images);
    if (!!images && images.length) {
      return !!images[randomizedIndex]
        ? images[randomizedIndex].src
        : images[0].src;
    }
  }
}

export const sectionHeaderContainerResolver = (registry, data, template) => {
  const sectionHeader = data.sectionHeader
    ? data.sectionHeader
    : data.constructor === Array
    ? data
    : [data];
  return {
    sectionHeader,
    template,
  };
};
